import { Config } from './interfaces/config.interface';

const config: Config = {
  graphqlApi: 'http://localhost:4000/employer',
  graphqlPublicApi: 'http://localhost:4000/public',
  graphqlSocketUri: 'ws://localhost:4000/employer/subscriptions',
  publicOpeningsUrl: 'http://localhost:8081/search',
};

const ENV = process.env.ENV;

if (ENV === 'production') {
  config.gtmToken = 'GTM-T6DKK3K';
  config.sentryDsn = 'https://d8645e2b9f854c99b63ce005d5d9b4e8@sentry.io/1552571';
  config.graphqlApi = 'https://api.meetfrank.com/employer';
  config.graphqlPublicApi = 'https://api.meetfrank.com/public';
  config.graphqlSocketUri = 'wss://api.meetfrank.com/employer/subscriptions';
  config.intercomAppId = 't1civ5yf';
  config.publicOpeningsUrl = 'https://app.meetfrank.com/search';
} else if (ENV === 'staging') {
  config.graphqlApi = 'https://api.mfstaging.xyz/employer';
  config.graphqlPublicApi = 'https://api.mfstaging.xyz/public';
  config.graphqlSocketUri = 'wss://api.mfstaging.xyz/employer/subscriptions';
  config.publicOpeningsUrl = 'https://app.mfstaging.xyz/search';
} else if (ENV === 'test') {
  const SERVER_PORT = process.env.SERVER_PORT || 4200;
  config.graphqlApi = `http://localhost:${SERVER_PORT}/api/graphql`;
  config.graphqlPublicApi = `http://localhost:${SERVER_PORT}/api/graphql`;
  config.graphqlSocketUri = `ws://localhost:${SERVER_PORT}/api/graphql/subscriptions`;
}

export default config;
